import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenIcon } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    icon: '📋',
    name: 'Evaluación Nutricional'
  }, {
    icon: '💊',
    name: 'Micronutrientes'
  }, {
    icon: '🩸',
    name: 'Síndrome Metabólico'
  }, {
    icon: '🫀',
    name: 'Patologías Frecuentes'
  }, {
    icon: '⚖️',
    name: 'Desnutrición'
  }, {
    icon: '📈',
    name: 'Seguimiento Clínico'
  }];
  const extras = ['Plantillas listas', 'Checklists clínicos', 'Protocolos aplicables', 'Fichas de seguimiento'];
  return <section className="pt-4 pb-8" data-id="element-232">
      <div className="max-w-3xl mx-auto px-3" data-id="element-233">
        <FadeIn className="text-center mb-5" data-id="element-234">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-235">
            📦 Qué <span className="text-accent" data-id="element-236">recibís</span>
          </h2>
          <p className="text-sm text-white/50 font-medium" data-id="element-237">
            6 Tomos Clínicos listos para usar
          </p>
        </FadeIn>

        <FadeIn data-id="element-238">
          <div className="space-y-2 mb-5" data-id="element-239">
            {tomos.map((tomo, idx) => <div key={idx} className="flex items-center gap-3 bg-surface border border-accent/15 rounded-lg px-4 py-2.5" data-id="element-240">
                <span className="text-lg shrink-0" data-id="element-241">{tomo.icon}</span>
                <span className="text-white/90 text-sm md:text-base font-medium" data-id="element-242">
                  {tomo.name}
                </span>
              </div>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-243">
          <div className="flex flex-wrap justify-center gap-2 mb-4" data-id="element-244">
            {extras.map((item, idx) => <span key={idx} className="inline-flex items-center gap-1.5 bg-accent/10 border border-accent/20 text-accent text-xs md:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-245">
                ✔ {item}
              </span>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-246">
          <p className="text-center text-white/70 text-sm md:text-base font-bold" data-id="element-247">
            📚 +1200 páginas reales de consulta
          </p>
        </FadeIn>
      </div>
    </section>;
}